import gql from 'graphql-tag';

const UPDATE_SALESFORCE_OPPORTUNITY = gql`
  mutation UpdateSalesforceOpportunity($opportunityId: String!, $data: JSON!) {
    updateSalesforceOpportunity(opportunityId: $opportunityId, data: $data)
  }
`;

export default UPDATE_SALESFORCE_OPPORTUNITY;
